import { createFileRoute } from '@tanstack/react-router'
import { AdminClipDetailPage } from '#pages/admin/AdminClipDetailPage'

export const Route = createFileRoute('/_admin/admin/clips_/$clipId')({
  component: RouteComponent,
})

function RouteComponent() {
  const { clipId } = Route.useParams()
  return <AdminClipDetailPage clipId={clipId} />
}
